module.exports = __webpack_public_path__ + "static/img/2.2b06423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/sp/2.png
// module id = LoN4
// module chunks = 0